import { Translate } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { addStyles } from '../theme';
import type { LocationInputState } from './location.input.state';
import { CSS, Style } from './location.input.style';
import { LocationFieldInput } from './LocationField.input';

addStyles(Style);

export const LocationInput = {
	view(state: LocationInputState): MithrilVNode {
		return m('div', { className: CSS.container }, [
			m('table', { className: CSS.tableInputs }, [
				LocationFieldInput.view(state.latitude),
				LocationFieldInput.view(state.longitude),
				LocationFieldInput.view(state.altitude),
			]),
			state.hasError() ? m('span', { className: CSS.MDL.error + ' ' + CSS.error }, Translate(state.error)) : null,
		]);
	},
};
